import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { FaWhatsapp } from 'react-icons/fa';
import ScrollToTop from '../ScrollToTop/ScrollToTop';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
import { BsQuestionLg } from "react-icons/bs";
import { VscNewFile } from "react-icons/vsc";
import { TbApps } from "react-icons/tb";
import logo from './../../assets/images/logo/logo.png';
import logo2 from './../../assets/images/logo/light-logo.png';
import { fetchWebsiteSettings, selectWebsiteSettings  } from '../../redux/slices/settings/WebsiteSettingsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPhoneNumber, selectPhoneNumber } from '../../redux/slices/phoneNumberSlice';
const MainLayout = ({ isLoggedIn, children,onLogout,user }) => {
  const location = useLocation();
  const { translations, direction,language } = useLanguage();
  const t = translations;
  const dispatch = useDispatch();
  const services = useSelector(selectWebsiteSettings);
  const phoneNumberData = useSelector(selectPhoneNumber);

  useEffect(() => {
    dispatch(fetchPhoneNumber()); // Fetch phone number on mount
  }, [dispatch]);

  // Extract phone number (if available)
  const phoneNumber = phoneNumberData.find((item) => item.WebisteLinkType === 8)?.Value || 'No phone number';

  const navigate = useNavigate();
  useEffect(() => {
    dispatch(fetchWebsiteSettings(5)); // Fetch website settings on mount
  }, [dispatch]);
 // Mapping the services to create sublinks
 const sublinks = services.map((service) => ({
  label: language === 'Arabic' ? service?.ValueAr : service?.Value || 'Default Title',  // Conditionally use ValueAr or Value
  href: `/service/${service?.Id}`,  // Correct path for service id
}));

  const navLinks = [
      // { label: 'الرئيسية', href: '/', icon: <HiOutlineHome size={22} /> },
      {
        label: t.services,
        href: '#',
        icon: <TbApps size={22}/>,
        sublinks: sublinks,
      },
      ...(isLoggedIn ? [{ label: t.newRequest, href: '/new-request', icon: <VscNewFile size={22} /> }] : []),
  
      { label: t.whoWeAre, href: '/about', icon: <BsQuestionLg size={22}/> },
  
    ];

  // Check if the current route is sign in or sign up
  const isSignInPage = ['signin', 'signup', 'forget-password'].includes(location.pathname.toLowerCase().split('/').pop());
  const isMyAccountPage = location.pathname.startsWith('/my-account');

  return (
    <Box dir={direction}>
      {/* Only render Header and Footer if not on SignIn or SignUp page */}
      {!isSignInPage && (
        <>
          <Header phoneNumber={phoneNumber} logo={logo} logo2={logo2} navLinks={navLinks} user={user} onLogout={onLogout} isLoggedIn={isLoggedIn}  dir={direction} t={t}/>
          {!isMyAccountPage && (
          <a
            href={`https://api.whatsapp.com/send/?phone=${phoneNumber}&text=Hello!`}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-icon"
            data-aos="fade-in"
          >
            <FaWhatsapp size={35} color="#fff" />
          </a>
            )}
        </>
      )}
      {children}
      <ScrollToTop />
      {/* Only render Footer if not on SignIn or SignUp page */}
      {!isSignInPage && <Footer phoneNumber={phoneNumber} logo={logo2} navLinks={navLinks} LoggedIn={isLoggedIn} direction={direction} t={t}/>}
    </Box>
  );
};

export default MainLayout;
